/**
 * Search functionality
 **/

$(document).ready(function () {
  searchToggle();

  UpdateSearchForm();

  $(document).on(
    "change",
    ".c-search-filter-wrapper input, .c-search-filter-wrapper select",
    function (event) {
      UpdateSearchForm(event);
    }
  );
});

function searchToggle() {
  $(document)
    .find(".c-search-filter-toggle-button")
    .on("click", function (e) {
      // Expand or collapse this panel and change font awesome icon
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        $(".c-search-filter__form").removeClass("open");
        // $(this)
        //   .siblings(".c-search-filter-top__clear")
        //   .fadeOut()
        //   .removeClass("displayinline");
      } else {
        $(this).addClass("open");
        $(".c-search-filter__form").addClass("open");
        // $(this)
        //   .siblings(".c-search-filter-top__clear")
        //   .fadeIn()
        //   .addClass("displayinline");
      }
    });
}

/**
 * Re-assess the search form and refresh the UI
 * This is typically triggered on page load and when the form changes
 * @param event = change event when field changed
 **/
function UpdateSearchForm(event) {
  var target = false;
  if (typeof event !== "undefined" && $(event.target)) target = $(event.target);
  var form = $(document).find(".c-search-filter-wrapper");

  // if we're updating as part of a 'change' event
  if (target) {
    var inputs = target
      .closest(".field.checkboxset")
      .find('input[type="checkbox"]');

    // clicked the 'all' item, so uncheck everything else
    if (target.is('[value="all"]')) {
      inputs.filter(':not([value="all"])').prop("checked", false);

      // unchecked a normal item, and now nothing is selected, so select 'all'
    }

    // // toggled a normal item, so uncheck 'all' if not already
    // }
    else {
      inputs.filter('[value="all"]').prop("checked", false);
    }

    // no target, so this is our initial load
  } else {
    // loop all of the checkboxes
    form.find(".field.checkboxset").each(function (eq, field) {
      var field = $(field);
      var inputs = field.find('input[type="checkbox"]');

      // if nothing is selected, select the 'all' item
      if (inputs.filter(':not([value="all"]):checked').length <= 0) {
        inputs.filter('[value="all"]').prop("checked", true);
        // if everything is selected then just make 'all' selected
      } else if (inputs.filter(":checked").length >= inputs.length) {
        inputs.filter(":checked").prop("checked", false);
        inputs.filter('[value="all"]').prop("checked", true);
      }
    });
  }
}
